import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useTermsAndConditionsStyles = makeStyles((theme: Theme) =>
  createStyles({
    topBar: {
      display: "flex",
      justifyContent: "space-between",
      padding: "15px 10px 0 10px",
    },

    buttonRoot: {
      height: "34px",
    },

    pageContainer: {
      color: "var(--col-navy-500)",
      textAlign: "left",
    },

    titleContainer: {
      padding: "40px 0 24px 0",
      fontSize: "48px",
      fontWeight: "bold",
      letterSpacing: "1.2px",
      textAlign: "center",
      [theme.breakpoints.only("xs")]: {
        fontSize: "32px",
      },
    },

    bodyContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      margin: "0 94px 56px 94px",
      [theme.breakpoints.only("sm")]: {
        margin: "0 56px 56px 56px",
      },
      [theme.breakpoints.only("xs")]: {
        margin: "0 16px 32px 16px",
      },
    },

    subTitle: {
      width: "100%",
      fontSize: "24px",
      paddingTop: "32px",
      fontWeight: "bold",
      [theme.breakpoints.only("xs")]: {
        fontSize: "20px",
      },
    },

    paragraph: {
      width: "100%",
      paddingTop: "16px",
    },

    list: {
      paddingTop: "16px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
  })
);
